module.exports = __webpack_public_path__ + "img/note-white-used.b2251da4.svg";